import { render, staticRenderFns } from "./MapPaymentTermsCheckbox.vue?vue&type=template&id=a6d7e0a6&scoped=true&lang=html&"
import script from "./MapPaymentTermsCheckbox.vue?vue&type=script&lang=js&"
export * from "./MapPaymentTermsCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MapPaymentTermsCheckbox.vue?vue&type=style&index=0&id=a6d7e0a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d7e0a6",
  null
  
)

export default component.exports